import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Dropdown, MenuItem } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faHistory } from '@fortawesome/pro-solid-svg-icons';
import {
  downloadImportSummary,
  downloadOriginalFile,
  downloadSkippedRecords,
  revertFile
} from '../store/actions/import_object';

export class ImportActions extends React.Component {
  static propTypes = {
    files: PropTypes.object.isRequired,
    selectedFileId: PropTypes.number,
    onDownloadImportSummary: PropTypes.func.isRequired,
    onDownloadOriginalFile: PropTypes.func.isRequired,
    onDownloadSkippedRecords: PropTypes.func.isRequired,
    onRevertFile: PropTypes.func.isRequired
  }

  render() {
    const {
      files,
      selectedFileId,
      onDownloadImportSummary,
      onDownloadSkippedRecords,
      onDownloadOriginalFile,
      onRevertFile
    } = this.props;

    return (
      <Dropdown className="import-actions">
        <Dropdown.Toggle>
          Actions
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <MenuItem key="import-summary" name="import-summary" onClick={onDownloadImportSummary}>
            {this.renderIcon(faDownload)} Download Import Summary
          </MenuItem>
          <MenuItem key="skipped" name="skipped" onClick={onDownloadSkippedRecords}>
            {this.renderIcon(faDownload)} Download Skipped Records
          </MenuItem>
          <MenuItem key="original" name="original" onClick={onDownloadOriginalFile}>
            {this.renderIcon(faDownload)} Download Original File
          </MenuItem>
          {!files[selectedFileId].reverted &&
            <MenuItem key="revert-file" name="revert-file" onClick={onRevertFile}>
              {this.renderIcon(faHistory)} Revert File
            </MenuItem>
          }
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  renderIcon(icon) {
    return (
      <FontAwesomeIcon className="mr-3" icon={icon} />
    );
  }
}

const mapStateToProps = state => ({
  files: state.importObject.files,
  selectedFileId: state.ui.selectedFileId
});

const mapDispatchToProps = {
  onDownloadImportSummary: downloadImportSummary,
  onDownloadOriginalFile: downloadOriginalFile,
  onDownloadSkippedRecords: downloadSkippedRecords,
  onRevertFile: revertFile
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportActions);
